export default {"src":"/_next/static/media/close-thin-icon.38e18d22.svg","height":20,"width":20};